import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, useLocation } from "react-router-dom";
import "./GlobalStyles/global.css";
import { BottomNav } from "./Navigation/BottomNav";
import { YandexMetrika } from "./AnalyticsClient/YandexMetrika";
import { ClientLocationBootstrap } from "./Geo/ClientLocationBootstrap";

declare global {
  interface Window {
    ym?: (counterId: number, method: string, target?: string, params?: Record<string, unknown>) => void;
  }
}

const YandexMetrikaTracker = () => {
  const location = useLocation();

  useEffect(() => {
    YandexMetrika.hit(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

const AppShell = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  //const hideBottomNavigation = location.pathname === "/master-lending";
  const hideBottomNavigation = location.pathname.startsWith("/master-lending");

  return (
    <>
      <YandexMetrikaTracker />
      <App />
      {!isAdminRoute && !hideBottomNavigation && <BottomNav />}
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
